export class ResearchSearchItem {
    constructor(public backstopId: number,
                public displayName: string,
                public itemType: "PRODUCT" | "MANAGER" | "NOT_FOUND",
                public pageUrl: string,
                public tickerId: string | undefined,
    ) {
    }
}
